import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useAuth } from '../hooks/useAuth';
import { useHistory } from 'react-router';
import { Button, Col, Row } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import { PulseLoader } from 'react-spinners';
import { TermsOfUsePDF } from './TermsOfUsePDF';
import { TermsOfUseService } from 'src/share/services/termsOfUse';
import { loginActions } from '../store/actions';
import { ITermsOfUse, TermsOfUseUserStatus } from 'src/share/types/termsOfUse';
import routes from 'src/modules/Routing/routes';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { timestampToDateTimeString } from 'src/share/utils/utils';
import './termsOfUse.css';
import { RoutesModules } from 'src/modules/Routing/types';

interface ITermsOfUseProps {
  needsToAccept?: boolean;
}

const TermsOfUse = (props: ITermsOfUseProps) => {
  const [auth] = useAuth();
  const history = useHistory();
  const dispatch = useDispatch();
  const logout = () => dispatch(loginActions.logout(history));
  const setTermsOfUseStatus = (termsOfUseStatus: TermsOfUseUserStatus) => dispatch(loginActions.setTermsOfUserStatus(termsOfUseStatus));
  const [loading, setLoading] = React.useState<boolean>(true);
  const [termsOfUse, setTermsOfUse] = React.useState<ITermsOfUse | null>(null);
  const isTermsOfUseView = () => history.location.pathname.includes(routes.TERMSOFUSE) && !!!props.needsToAccept;
  const redirectTo = (path: string) => history.push(path);

  const loadTermsOfUseFile = async () => {
    try {
      const termsOfUseResponse = await TermsOfUseService.getCurrentTermsOfUse();
      if (termsOfUseResponse) {
        setTermsOfUse(termsOfUseResponse);
      }
      setLoading(false);
    } catch {
      setLoading(false);
      toastr.error('Error', 'There was a problem loading the Terms of use');
      redirectTo(routes.ROOT);
    }
  }

  React.useEffect(() => {
    loadTermsOfUseFile();
  }, []);

  const addUserAcceptance = async () => {
    try {
      setLoading(true);
      if (termsOfUse) {
        await TermsOfUseService.saveAcceptanceUser(termsOfUse.id);
        setTermsOfUseStatus(TermsOfUseUserStatus.AgreeUser);
        toastr.success('Terms of use', 'The terms of use were accepted');
        redirectTo(routes.ROOT);
      } else {
        toastr.error('Error', 'There was a problem accepting the terms of use');
      }
      setLoading(false);
    } catch {
      setLoading(false);
      toastr.error('Error', 'There was a problem accepting the terms of use');
    }
  }

  const onLaterAcceptance = async () => {
    if (auth.termsOfUseStatus === TermsOfUseUserStatus.ExpiredUser) {
      await logout();
      toastr.error('Error', 'You need to accept the terms of use');
    } else {
      setTermsOfUseStatus(TermsOfUseUserStatus.LaterUser);
      redirectTo(routes.HOME);
    }
  }

  return (
    <div className={`terms-of-use ${isTermsOfUseView() && termsOfUse && 'terms-of-use-view'} ${isTermsOfUseView() && !termsOfUse && 'no-terms-of-use'}`}>
      {!loading &&
        <div className="terms-of-use-content white-background">
          <Row>
            <Col className="col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
              {!isTermsOfUseView() ?
                <h3 className="title">We have updated our terms of use</h3> :
                <h3 className="title">GMCNgine terms of use</h3>
              }
              {termsOfUse && !isTermsOfUseView() &&
                <div className="descriptionContainer">
                  <p className="descriptionText">Pleases scroll down and read them. If you agree with them, please click the "Agree" button</p>
                  <p className="descriptionText">If you you have any questions, please contact us <a href="mailto:help@gmcngine.com">help@gmcngine.com</a></p>
                </div>}
            </Col>
          </Row>
          {termsOfUse && termsOfUse.url &&
            <Row>
              <Col className="col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                <div className="terms-of-use-pdf-container">
                  <TermsOfUsePDF file={termsOfUse.url} isFromUrl={true} />
                </div>
              </Col>
            </Row>}
          {termsOfUse && termsOfUse.url && !isTermsOfUseView() &&
            <Row>
              <Col className="col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                <div className="buttons-container">
                  <Button className="btn btn-blue float-right" onClick={() => addUserAcceptance()} disabled={loading}>Agree</Button>
                  <Button className="btn btn-grey float-right" onClick={() => onLaterAcceptance()} disabled={loading}>{auth.termsOfUseStatus === TermsOfUseUserStatus.ExpiredUser ? 'Logout' : 'Later'}</Button>
                </div>
              </Col>
            </Row>}
          {!termsOfUse && isTermsOfUseView() &&
            <Row>
              <Col className="col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                <h3 className="description">There are not terms of use uploaded yet</h3>
              </Col>
            </Row>}
          {termsOfUse && termsOfUse.url && isTermsOfUseView() && auth.termsOfUseStatus === TermsOfUseUserStatus.AgreeUser && termsOfUse.acceptances && termsOfUse.acceptances[auth.username] &&
            <Row>
              <Col className="col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                <h3 className="accepted">You accepted these terms of use on: {timestampToDateTimeString(termsOfUse.acceptances[auth.username].date)}</h3>
              </Col>
            </Row>}
        </div>}
      <div className="help-loader-sidebar">
        <PulseLoader
          size={20}
          color={"#393939"}
          loading={loading}
        />
      </div>
    </div>
  );
}

export const TermsOfUseView = TermsOfUse;
export default SidebarContainer(RoutesModules.SETTINGS)(TermsOfUse);



// WEBPACK FOOTER //
// ./src/modules/Auth/TermsOfUse/TermsOfUse.tsx